"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.multiply = void 0;
const decimal_js_1 = __importDefault(require("decimal.js"));
const exception_1 = require("../exception");
const utils_1 = require("./utils");
const mulNumber = (a, b) => (0, utils_1.numberValueBinaryOperator)(a, b, decimal_js_1.default.prototype.mul);
const mulVector = (a, b) => (0, utils_1.vectorValueBinaryOperator)(a, b, exports.multiply);
const mulVectorByNumber = (a, b) => (0, utils_1.vectorValueNumberBinaryOperator)(a, b, exports.multiply);
const multiply = (a, b) => {
    if (a.type === b.type) {
        switch (a.type) {
            case "Number":
                return mulNumber(a, b);
            case "Vector":
                return mulVector(a, b);
        }
    }
    else if (b.type === "Number") {
        if (a.type === "Vector") {
            return mulVectorByNumber(a, b);
        }
    }
    throw new exception_1.TypeError(`Cannot multiply ${a.type.toLowerCase()} with ${b.type.toLowerCase()}.`);
};
exports.multiply = multiply;
